import { createContext, type Dispatch, type SetStateAction } from "react";
import type {
  AllInputData,
  CalculatedDataValue,
  SliderValues,
} from "./types/context.types";

/**
 * Contexts are created without a runtime default (matching the original
 * `createContext()` behaviour); a Provider always supplies a value before any
 * consumer reads it. The boundary cast keeps consumers free of null checks
 * while still exposing typed fields.
 */
const noDefault = <T>(): T => undefined as unknown as T;

export const CalculatedDataContext = createContext<CalculatedDataValue>(
  noDefault<CalculatedDataValue>(),
);
export const AllInputDataContext = createContext<AllInputData>(
  noDefault<AllInputData>(),
);
export const SliderValuesContext = createContext<SliderValues>(
  noDefault<SliderValues>(),
);
export const SetSliderValuesContext = createContext<
  Dispatch<SetStateAction<SliderValues>>
>(noDefault<Dispatch<SetStateAction<SliderValues>>>());
export const UserLinkContext = createContext<string>(noDefault<string>());
